import { motion } from "framer-motion";
import { SECTORS, IMAGES } from "../../data/content";

export const Sectors = () => {
  return (
    <section
      id="sectors"
      data-testid="sectors-section"
      className="relative bg-background py-24 md:py-32 border-t border-border scroll-mt-16"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 grid lg:grid-cols-2 gap-14 lg:gap-24 items-center">
        <div className="relative">
          <motion.div
            initial={{ opacity: 0, scale: 1.05 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
            className="group relative aspect-[4/5] overflow-hidden border border-border"
          >
            <img
              src={IMAGES.cargo}
              alt="Global export logistics"
              className="w-full h-full object-cover img-industrial"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background/70 to-transparent" />
            <span className="absolute bottom-6 left-6 font-mono-ibm text-xs tracking-widest text-foreground">
              [ PAN-INDIA & WORLDWIDE EXPORT ]
            </span>
          </motion.div>
        </div>

        <div>
          <p className="font-mono-ibm text-xs tracking-widest uppercase text-primary mb-4">
            / Sectors Served
          </p>
          <h2 className="font-display uppercase leading-[0.88] tracking-tight text-5xl md:text-7xl mb-12">
            Cargo We
            <br />
            Protect
          </h2>

          <div className="border-t border-border">
            {SECTORS.map((s, i) => (
              <motion.div
                key={s.no}
                data-testid={`sector-${s.no}`}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="group flex items-start gap-6 py-6 border-b border-border hover:bg-secondary/40 transition-colors px-2 -mx-2"
              >
                <span className="font-mono-ibm text-xs tracking-widest text-muted-foreground pt-2">
                  {s.no}
                </span>
                <div>
                  <h3 className="font-display uppercase tracking-tight text-2xl md:text-3xl group-hover:text-primary transition-colors">
                    {s.name}
                  </h3>
                  <p className="text-sm text-muted-foreground mt-1 max-w-md leading-relaxed">
                    {s.line}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
